/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Resend_Payment_LinkInputs */

const en_orders_resend_payment_link = /** @type {(inputs: Orders_Resend_Payment_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Payment Link`)
};

const es_orders_resend_payment_link = /** @type {(inputs: Orders_Resend_Payment_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar link de pago`)
};

/**
* | output |
* | --- |
* | "Resend Payment Link" |
*
* @param {Orders_Resend_Payment_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_resend_payment_link = /** @type {((inputs?: Orders_Resend_Payment_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Resend_Payment_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_resend_payment_link(inputs)
	return es_orders_resend_payment_link(inputs)
});